import * as React from 'react'
import * as Redux from 'react-redux'
import styled from 'styled-components'

import * as models from '@owl-nest/models'
import { Status } from '@owl-nest/redux-wrapper'
import { Link as RouterLink } from 'react-router-dom'
import { Link, Spinner, styles as S } from '@ulule/owl-kit-components/next'
import { t, tn } from '@owl-nest/localize'
import * as service from '@owl-nest/services'
import * as api from '@owl-nest/api-client/latest'
import * as hooks from '@owl-nest/hooks'

import * as supporterReducer from '../../../../../../reducers/supporter'
import * as supporterAction from '../../../../../../actions/supporter'
import { RootState } from '../../../../../../reducers'
import { Backer } from './Backer'
import * as projectModel from '../../../../../models/project'
import * as supporterModel from '../../../../../models/supporter'
import { useNavigation } from '../../../../../hooks/useNavigation'
import * as UFE from '../../../../../../UFE'

import * as Styles from '../../../style'
import { PATHS } from '../../../../../paths'
import { TRACKING_SOURCE } from '../../../utils/trackerEnums'

const LinkSeeAll = styled(S.copy.S)`
  margin-top: 20px;
`

const Wrapper = styled.div`
  &:empty {
    display: none;
  }
`

export function Supporters(): React.ReactElement<unknown> {
  const dispatch = Redux.useDispatch()
  const navigation = useNavigation()
  const supporter = Redux.useSelector<RootState, supporterReducer.State>((state) => state.application.supporter)
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)

  const useProjectOrder = service.order.useProjectOrders(project.id, {
    params: {
      limit: 10,
      extraFields: ['latest_user_project_comment'],
    },
    fetchOnMount: false,
  })
  const orderPageList = hooks.data(useProjectOrder.response)

  const supporterCount = project.supporters_count
  const ordersCount = project.orders_count

  const wrapperRef = React.useRef<HTMLDivElement>(null)
  hooks.useLazyInitialLoad({
    target: wrapperRef,
    load: () => {
      if (
        supporterCount > 0 &&
        models.project.isOnline(project) &&
        useProjectOrder.response.status === hooks.QueryStatus.PRISTINE
      ) {
        useProjectOrder.query()
      }
    },
  })

  return (
    <Wrapper ref={wrapperRef}>
      {supporter.status.load === Status.PENDING ? (
        <Spinner />
      ) : (
        supporterCount > 0 && (
          <Styles.SidebarItem>
            <Styles.SidebarHeading>
              <S.heading.M>
                {tn('%(ordersCount)d contribution', '%(ordersCount)s contributions', ordersCount || supporterCount, {
                  ordersCount: ordersCount || supporterCount,
                })}
              </S.heading.M>
            </Styles.SidebarHeading>
            {orderPageList?.[0].orders.slice(0, 5).map((order) => {
              return (
                order.user && (
                  <Backer
                    key={order.id}
                    supporter={{
                      ...order.user,
                      latest_project_comment: order.latest_user_project_comment ?? order.user.latest_project_comment,
                      latest_project_order: order as api.Order,
                    }}
                    project={project}
                    variant="light"
                    source={TRACKING_SOURCE.PROJECT_BACKERS_LISTING}
                  />
                )
              )
            })}
            <LinkSeeAll>
              <Link forwardedAs={RouterLink} kind="secondary" to={navigation.pathTo(PATHS.SUPPORTERS)}>
                {t('See all backers')}
              </Link>
            </LinkSeeAll>
          </Styles.SidebarItem>
        )
      )}
    </Wrapper>
  )
}
